$(document).ready(function () {
  if (window.innerWidth > 767) {
    $(".header-menu-product__list-container").slick({
      slidesToScroll: 2,
      slidesToShow: 2,
      autoplay: false,
      autoplaySpeed: 3000,
      arrows: true
    });
  }
  if (window.innerWidth < 767) {
    setHeightForFooterLink();
    $(".header-menu-slick-container").slick({
      infinite: true,
      slidesToShow: 1.5,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 3000,
      arrows: true,
      centerMode: false,
      initialSlide: 0,
      focusOnSelect: true,
    });
  }
  setHeightForSubMenuInHeaderMenu();
  // var menuItemLength = document.getElementsByClassName(
  //   "header-menu-product-item"
  // ).length;
  // var menuAllHeaderSlideLength;
  // var numberInHeaderSlide = 0;
  // var menuHeaderSlideWidth;
  // if (window.innerWidth > 767) {
  //   menuHeaderSlideWidth = $(
  //     ".header-menu-product__list-container"
  //   ).innerWidth();
  //   menuAllHeaderSlideLength =
  //     document.getElementsByClassName("header-menu-product__list-sub-container")
  //       .length - 1;
  // } else {
  //   menuHeaderSlideWidth =
  //     $(".header-menu-product__list-container").innerWidth() * (2 / 3);
  //   menuAllHeaderSlideLength = document.getElementsByClassName(
  //     "header-menu-product__list-sub-container"
  //   ).length;
  // }

  // setMinWidthForHeaderListCategoryContainer(menuItemLength);
  // $(".header-menu-product-button").click(function () {
  //   if (window.innerWidth > 767) {
  //     if ($(this).hasClass("next")) {
  //       if (numberInHeaderSlide < menuAllHeaderSlideLength) {
  //         numberInHeaderSlide = numberInHeaderSlide + 1;
  //       } else {
  //         numberInHeaderSlide = 0;
  //       }
  //     } else {
  //       if (numberInHeaderSlide > 0) {
  //         numberInHeaderSlide = numberInHeaderSlide - 1;
  //       } else {
  //         numberInHeaderSlide = menuAllHeaderSlideLength;
  //       }
  //     }
  //   } else {
  //     if ($(this).hasClass("next")) {
  //       if (numberInHeaderSlide <= menuAllHeaderSlideLength) {
  //         numberInHeaderSlide = numberInHeaderSlide + 1;
  //       } else {
  //         numberInHeaderSlide = 0;
  //       }
  //     } else {
  //       if (numberInHeaderSlide > 0) {
  //         numberInHeaderSlide = numberInHeaderSlide - 1;
  //       } else {
  //         numberInHeaderSlide = menuAllHeaderSlideLength;
  //       }
  //     }
  //   }
  //   var px = numberInHeaderSlide * -menuHeaderSlideWidth;
  //   $(".header-menu-product__list-container").css(
  //     "transform",
  //     "translate(" + px + "px, 0)"
  //   );
  // });

  $(".image-link-block-1").mouseenter(function () {
    $(this).parent().removeClass("right");
    $(this).parent().addClass("left");
  });
  $(".image-link-block-0").mouseenter(function () {
    $(this).parent().removeClass("left");
    $(this).parent().addClass("right");
  });
  $(".image-link-block")
    .mouseleave(function () {
      $(this).parent().removeClass("right");
      $(this).parent().removeClass("left");
    })
    .mouseleave();

  if ($(".html-balance").attr("lang") == "en") {
    addEnglishSubForCollection();
  }

  $(document).ready(function () {
    var danhSachAnh = window.danhSachAnh || []; // Danh sách ảnh từ metafield
    var productsPerPage = parseInt($("#load-more-btn").data("products-per-page"), 10) || 8;
    var totalImages = parseInt($("#load-more-btn").data("list-image-mobile-will-show"), 10) || 0;
    var imagesPerPage = parseInt($("#load-more-btn").data("list-image-mobile-each-page-show"), 10) || 2;
    var imagesAlreadyShown = parseInt($("#load-more-btn").data("list-image-mobile-count"), 10) || 0;

    // Xác định số ảnh đã hiển thị từ lần load đầu tiên
    var initialImagesShown = Math.floor(productsPerPage / 4);
    var imageIndex = initialImagesShown;
    var count = productsPerPage;

    $("#load-more-btn").click(function () {
        var currentPage = $(this).data("page");
        var nextPage = currentPage + 1;
        var collectionHandle = $(this).data("handle");
        var totalPages = $(this).data("pages");
        var loadMoreText = $(this).data("loadmore");
        var loadingText = $(this).data("loading");

        $.ajax({
            url: "/collections/" + collectionHandle + "?page=" + nextPage,
            type: "GET",
            beforeSend: function () {
                $("#load-more-btn").text(loadingText).addClass("isLoading");
            },
            success: function (data) {
                var newProducts = $(data).find("#product-grid .grid__item");

                if (newProducts.length > 0) {
                    var newItems = [];

                    newProducts.each(function (index, product) {
                        newItems.push(product);
                        count++; //Cập nhật số sản phẩm đã render

                        // Cứ 4 sản phẩm thì chèn 1 hình ảnh từ danhSachAnh nếu có ảnh
                        if (count % 4 === 0 && imageIndex < totalImages) {
                            var imageUrl = danhSachAnh[imageIndex];

                            // Kiểm tra nếu imageUrl hợp lệ
                            if (imageUrl && imageUrl.trim() !== "") {
                                var imageHtml = `
                                    <li class="grid__thumbnail-image">
                                        <img class="grid__thumbnail-image-ngang" src="${imageUrl}" alt="Collection Thumbnail">
                                    </li>`;
                                newItems.push($(imageHtml)); // Thêm vào danh sách chèn
                            }

                            imageIndex++; // Chỉ tăng index nếu đã dùng ảnh hợp lệ
                        }
                    });

                    // Thêm sản phẩm và ảnh vào #product-grid
                    $("#product-grid").append(newItems);

                    // Cập nhật trạng thái nút Load More
                    $("#load-more-btn").data("page", nextPage).html("<span>" + loadMoreText + "</span>").removeClass("isLoading");

                    // Cập nhật số ảnh đã hiển thị
                    imagesAlreadyShown += imagesPerPage;
                    $("#load-more-btn").data("list-image-mobile-count", imagesAlreadyShown);

                    // Ẩn nút khi đã load hết
                    if (nextPage >= totalPages) {
                        $("#load-more-btn").addClass("hidden");
                    }
                } else {
                    $("#load-more-btn").addClass("hidden");
                }
            },
            error: function () {
                $("#load-more-btn").text("Load More");
                console.error("Error loading products!");
            },
        });
    });
  });

  $(".footer-heading").click(function () {
    if ($(this).hasClass("show")) {
      $(this).removeClass("show");
      $(this).next().removeClass("show");
    } else {
      $(this).addClass("show");
      $(this).next().addClass("show");
    }
  });

  $(".popup-close").click(function () {
    if ($(this).hasClass("popup-closeheader-menu")) {
      $(".order-status-popup").removeClass("active");
      clearValueInTrackOrder();
    } else {
      popupAction(true);
    }
  });

  $(".popupClassAction").click(function () {
    var idActive = $(this)[0].id;
    popupClassAction(idActive);
    $(".html-balance").addClass("PopupShow");
    if($(this).hasClass("header-menu-hambuger") || $(this).hasClass("header-menu-popupClassAction")) {
      $(".order-status-popup").addClass("transition-0-important");
    };
  });

  $(".balance-popup").on("click", function () {
    popupShow = $(".balance-popup");
    // const popupElement = $('.balance-popup-container')[0];
    const popupElement = $(this).find(".balance-popup-container")[0];
    if (popupShow.hasClass("active")) {
      if (!popupElement.contains(event.target)) {
        if($(".balance-popup").hasClass("order-status-popup")) {
          clearValueInTrackOrder();
        };
        popupAction(true);
      }
    }
  });

  $(".filter_type__type").on("click", function () {
    $(".filter_type__type").removeClass("active");
    $(this).addClass("active");
    if ($(this).hasClass("filter_type__grid")) {
      activePLPType(false);
    } else {
      activePLPType(true);
    }
  });

  // Track Order



  document.getElementById("find-order-button").addEventListener("click", function () {
      $('#send-email-status').addClass("hidden");
      const emailElement = document.getElementById("OrderStatus-email");
      const phoneElement = document.getElementById("OrderStatus-phone");
      const email = emailElement.value.trim();
      const phone = phoneElement.value.trim();

      // Validate Email
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      if (!emailRegex || !emailRegex.test(email)) {
        $(emailElement)?.next().removeClass("hidden");
        return;
      } else {
        $(emailElement)?.next().addClass("hidden");
      }

      // Validate phone
      const phoneRegex = /^(?:\+84|0)(?:\d{9}|\d{10})$/;
      if (!phoneRegex || !phoneRegex.test(phone)) {
        $(phoneElement)?.next().removeClass("hidden");
        return;
      } else {
        $(phoneElement)?.next().addClass("hidden");
      }

      // Cấu hình SMTP
      const smtpConfig = {
        Host: "email-smtp.ap-southeast-2.amazonaws.com",
        Username: "AKIAR646LMPGRLQZQFVM",
        Password: "BKZhe/bTfWinaRBTphCJBkhNn2044nJRFjv8kp1O2FOD", // Thay bằng mật khẩu SMTP
        Port: 587,
      };

      const emailData = {
        phone: phone,
        email: email,
      };

      $('#OrderStatus-loading').removeClass('hidden');
      // Send the email using EmailJS
      emailjs.send("service_khfkig8", "template_3xvx5i8", emailData)
      // emaijs for test
      // emailjs.send("service_ir5kk07", "template_qbzrh3l", emailData)
      .then(() => {
        setTimeout(() => {
          $(".order-status-popup").removeClass("active");
          $('#OrderStatus-loading').addClass('hidden');
          emailElement.value = "";
          phoneElement.value ="";
          $('#send-email-status').removeClass("hidden");

          // Remove send-email-status after 5s
          setTimeout(() => {
            $('#send-email-status').addClass("hidden");
          }, 5000);
        }, 1500);
      })
      .catch((error) => {
        $('#send-email-status').removeClass('hidden');
        setTimeout(() => {
          $('#send-email-status').addClass("hidden");
        }, 5000);
        $('.order-status-content p').innerText = 'Email sent successfully!';
      });
    });

  // End Track Order

  //Render Custom JS Filter
  initRenderFilterFacet();

  $(document).on(
    "click",
    "#active-facets__button-remove-all, .list-menu__item, .facets__reset, .mobile-facets__clear",
    function (e) {
      // Update URL with the selected sort_by value
      const params = new URLSearchParams(window.location.search);
      const sortBySelectedValue = params.get("sort_by");

      const url = $(this).attr("href");
      $.get(url, function (response) {
        // Delay initialization slightly to ensure DOM is updated
        setTimeout(() => {
          initRenderFilterFacet(sortBySelectedValue);
        }, 1000);
      });
    }
  );

  // $(".header__icon--cart").on("click", function (event) {
  //   event.stopPropagation(); // Ngăn sự kiện click lan ra document

  //   cartNotificationShow = $(".cart-notification");
  //   if (cartNotificationShow.hasClass("active")) {
  //     cartNotificationShow.removeClass("active");
  //   } else {
  //     cartNotificationShow.addClass("active");
  //   }
  // });

  $(document).on("click", function (event) {
    if (!$(event.target).closest(".cart-notification, .header__icon--cart").length) {
      $(".cart-notification").removeClass("active");
    }
  });

  document.querySelectorAll('.th_wl_col_btn').forEach(function(btn) {
    const card = btn.closest('.card-wishlist'); // Tìm phần tử cha

    btn.addEventListener('click', function() {
        const flexContainer = btn.querySelector('.d-flex');

        if (!flexContainer || card.classList.contains('isLoading')) return;

        // Thêm class loading vào card
        card.classList.add('isLoading');

        // Theo dõi sự thay đổi toàn bộ trong th_wl_col_btn
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'childList') {
                    const newFlex = btn.querySelector('.d-flex');

                    // Khi d-flex mới xuất hiện hoặc thay đổi
                    if (newFlex && newFlex !== flexContainer) {
                        card.classList.remove('isLoading');
                        
                        // Ngừng theo dõi sau khi thay đổi hoàn tất
                        observer.disconnect();
                    }
                }
            });
        });

        // Bắt đầu theo dõi th_wl_col_btn
        observer.observe(btn, { childList: true, subtree: false });
    });
  });

  let policyContainer = document.querySelector(".shopify-policy__container");
  let breadcrumb = document.querySelector(".breadcrumb-container");
  if (policyContainer) {
    var refundTitle = document.querySelector("h1").innerHTML;
  }

  if (policyContainer && refundTitle == "Refund policy") {
    if($(".html-balance").attr("lang") == "en") {
      document.querySelector("h1").innerHTML = "EXCHANGE & RETURN POLICY";
    }
  }
  
  if (policyContainer && breadcrumb) {
    breadcrumb.style.display = "none";
  }
});

function activePLPType(isOneColumnType) {
  if (isOneColumnType) {
    $(".plp-list").addClass("isOneColumn");
    activeButtonSection(false);
  } else {
    $(".plp-list").removeClass("isOneColumn");
    activeButtonSection(true);
  }
}

function activeButtonSection(isGrid) {
  if (isGrid) {
    $(".collection-bottom-section").removeClass("bottom-section-oneColumn");
    $(".collection-bottom-section").addClass("bottom-section-grid");
  } else {
    $(".collection-bottom-section").removeClass("bottom-section-grid");
    $(".collection-bottom-section").addClass("bottom-section-oneColumn");
  }
}

function setHeightForFooterLink() {
  footerLink = document.getElementsByClassName("footer-link");
  for (i = 0; i < footerLink.length; i++) {
    var descriptionHeight = $(footerLink[i].clientHeight)[0];
    var descriptionHeightPx = descriptionHeight + "px";
    $(footerLink[i]).css("height", descriptionHeightPx);
    $(footerLink[i]).removeClass("show");
    $(footerLink[i]).prev().removeClass("show");
  }
}

function clearValueInTrackOrder() {
  $(".info-input-wrapper .error").addClass("hidden");
  document.getElementById("OrderStatus-email").value ="" ;
  document.getElementById("OrderStatus-phone").value ="" ;
  $('#send-email-status').addClass("hidden");
  $('#OrderStatus-loading').addClass('hidden');
  $(".order-status-popup").removeClass("transition-0-important");
}

// function setMinWidthForHeaderListCategoryContainer(itemLength) {
//   if (window.innerWidth > 767) {
//     if (itemLength % 2 !== 0) {
//       itemLength = itemLength + 1;
//     }
//     var minWidth = itemLength * 50 + "%";
//     $(".header-menu-product__list-container").css("min-width", minWidth);
//   } else {
//     var minWidth = "calc(" + itemLength * ((2 / 3) * 100) + "% + 10px)";
//     $(".header-menu-product__list-container").css("min-width", minWidth);
//   }
// }

function setHeightForSubMenuInHeaderMenu() {
  var menuHeight = $(".contact-aboutus-link-container").height();
  var menuHeightPx = menuHeight + "px";
  if (menuHeight > 0) {
    $(".contact-aboutus-link-container").css("height", menuHeightPx);
    $(".contact-aboutus-link-container").addClass("isHide");
  }
}

$(".contact-aboutus-button").click(function () {
  if ($(this).hasClass("isShow")) {
    $(this).removeClass("isShow");
    $(".contact-aboutus-link-container").addClass("isHide");
  } else {
    $(this).addClass("isShow");
    $(".contact-aboutus-link-container").removeClass("isHide");
  }
});

function addEnglishSubForCollection() {
  if ($("#MainContent").hasClass("template-collection")) {
    subEnglistCollection();
  }
}

function checkHeaderProductSlide() {
  menuAllHeaderSlideLength = a.length;
}

function subEnglistCollection() {
  a = document.getElementsByClassName("facet-checkbox__text-label");
  for (i = 0; i < a.length; i++) {
    if ($(a[i]).hasClass("Ao")) {
      if ($(a[i]).hasClass("Bra")) {
        $(a[i])[0].innerHTML = "Bra";
      }
      if ($(a[i]).hasClass("Croptop")) {
        $(a[i])[0].innerHTML = "Croptop";
      }
    }
    if ($(a[i]).hasClass("Quan")) {
      if ($(a[i]).hasClass("Legging")) {
        $(a[i])[0].innerHTML = "Legging";
      }
      if ($(a[i]).hasClass("Short")) {
        $(a[i])[0].innerHTML = "Short";
      }
    }
    if ($(a[i]).hasClass("Set")) {
      $(a[i])[0].innerHTML = "Set";
    }
    if ($(a[i]).hasClass("Xam")) {
      $(a[i])[0].innerHTML = "Anthracite";
    }
    if ($(a[i]).hasClass("Den")) {
      $(a[i])[0].innerHTML = "Black";
    }
  }
}

function popupAction(isClickClosePopup) {
  if (isClickClosePopup) {
    $(".balance-popup").removeClass("active");
    $(".html-balance ").removeClass("PopupShow");
  } else {
    $(".balance-popup").addClass("active");
  }
}

function popupClassAction(classActive) {
  var ClassActive = "." + classActive;
  $(ClassActive).addClass("active");
}

async function fetchAndUpdateContent(url) {
  try {
    const response = await $.get(url);
    // Delay initialization slightly to ensure DOM is updated
    if (response) {
      setTimeout(() => {
        initRenderFilterFacet();
      }, 1000);
    }
  } catch (error) {
    console.error("Error fetching content:", error);
  }
}

function initRenderFilterFacet(sortBySelectedValue) {
  renderSortByFilter(sortBySelectedValue);
  renderFilterPriceFacetSlider();
}

function renderSortByFilter(sortBySelectedValue) {
  let toggleButton, menu;

  if ($(window).width() <= 768) {
    // Mobile view
    toggleButton = $("#SortByToggleMobile");
    menu = $("#SortByMenuMobile");
  } else {
    // Desktop view
    toggleButton = $("#SortByToggle");
    menu = $("#SortByMenu");
  }

  if (sortBySelectedValue) {
    // Update URL with the selected sort_by value
    const params = new URLSearchParams(window.location.search);
    params.set("sort_by", sortBySelectedValue);
    window.location.search = params.toString();
  }

  // Remove any previously attached click event listeners to avoid duplication
  toggleButton.off("click");

  // Add the click event listener
  if (toggleButton.length) {
    toggleButton.on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      const sortByToggle = $(this).closest(".sort-by-toggle");
      const isOpen = $(this).attr("aria-expanded") === "true";
      $(this).attr("aria-expanded", !isOpen);
      sortByToggle.toggleClass("open");
      menu.prop("hidden", isOpen);

      $(".collection").removeClass("overflow-hidden-mobile");
      $(".mobile-facets__disclosure").removeClass("menu-opening");
      $(".mobile-facets__disclosure").removeAttr("open");
    });
  }

  if (toggleButton.length && menu.length) {
    // Handle option selection
    menu.on("click", ".sort-by-option", function (event) {
      event.preventDefault();
      const option = $(this);
      const selectedValue = option.data("value");

      // Update URL with the selected sort_by value
      const params = new URLSearchParams(window.location.search);
      params.set("sort_by", selectedValue);
      window.location.search = params.toString();
    });

    // Close menu when clicking outside
    $(document).on("click", function (event) {
      if (
        !menu.is(event.target) &&
        !menu.has(event.target).length &&
        !toggleButton.is(event.target)
      ) {
        menu.prop("hidden", true);
        toggleButton.attr("aria-expanded", false);
        toggleButton.removeClass("open");
      }
    });
  }
}

function renderFilterPriceFacetSlider() {
  let $slider, $minPriceInput, $maxPriceInput, $formSection, $clearFilterButton;
  const $stepPriceInput = $("#step-price-input");

  if ($(window).width() <= 768) {
    // Mobile view
    $slider = $("#price-slider-mobile");
    $minPriceInput = $("#min-price-input-mobile");
    $maxPriceInput = $("#max-price-input-mobile");
    $formSection = $("#price-filter-form-section-mobile");
    $clearFilterButton = $("#clear-price-range-filter-mobile");
  } else {
    // Desktop view
    $slider = $("#price-slider");
    $minPriceInput = $("#min-price-input");
    $maxPriceInput = $("#max-price-input");
    $formSection = $("#price-filter-form-section");
    $clearFilterButton = $("#clear-price-range-filter");
  }

  const MIN_PRICE_ENUM = $minPriceInput.data("value");
  const MAX_PRICE_ENUM = $maxPriceInput.data("value");
  const STEP_PRICE_ENUM = $stepPriceInput.data("value");

  if ($slider.length && $slider[0].noUiSlider) {
    // Destroy the existing slider instance
    $slider[0].noUiSlider.destroy();
  }

  const urlParams = new URLSearchParams(window.location.search);
  const minPrice = urlParams.get("filter.v.price.gte") || MIN_PRICE_ENUM;
  const maxPrice = urlParams.get("filter.v.price.lte") || MAX_PRICE_ENUM;

  // Set values to your slider or form inputs
  if ($minPriceInput.length) {
    $minPriceInput.val(minPrice);
  }
  if ($maxPriceInput.length) {
    $maxPriceInput.val(maxPrice);
  }

  if (typeof noUiSlider !== "undefined" && $slider.length) {
    noUiSlider.create($slider[0], {
      start: [
        parseInt($minPriceInput.val() || MIN_PRICE_ENUM),
        parseInt($maxPriceInput.val() || MAX_PRICE_ENUM),
      ],
      connect: true,
      range: {
        min: MIN_PRICE_ENUM,
        max: MAX_PRICE_ENUM,
      },
      step: STEP_PRICE_ENUM,
      tooltips: [
        {
          to: function (value) {
            return (
              new Intl.NumberFormat("en-US", {
                maximumFractionDigits: 0, // No decimals
              }).format(value) + "đ"
            );
          },
          from: function (value) {
            return Number(value.replace(/[^0-9.-]+/g, "")); // Remove non-numeric characters
          },
        },
        {
          to: function (value) {
            return (
              new Intl.NumberFormat("en-US", {
                maximumFractionDigits: 0, // No decimals
              }).format(value) + "đ"
            );
          },
          from: function (value) {
            return Number(value.replace(/[^0-9.-]+/g, ""));
          },
        },
      ],
      format: {
        to: function (value) {
          return Math.round(value); // Slider internally works with plain numbers
        },
        from: function (value) {
          return Number(value);
        },
      },
    });

    const $priceNumberFrom = $(".price-number-from");
    const $priceNumberTo = $(".price-number-to");

    $slider[0].noUiSlider.on("update", function (values) {
      const formattedMin = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(values[0]);
      const formattedMax = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(values[1]);
  
      // Gán giá trị vào các phần tử HTML
      $priceNumberFrom.text(`${formattedMin}đ`);
      $priceNumberTo.text(`${formattedMax}đ`);
    });

    $slider[0].noUiSlider.on("change", function (values, handle) {
      // Update hidden input fields with the slider values
      $minPriceInput.val(values[0]); // Set min price
      $maxPriceInput.val(values[1]); // Set max price

      const $form = $formSection.closest("form");
      if ($form.length) {
        $form.submit();
      }
    });

    $clearFilterButton.on("click", function (e) {
      e.preventDefault();
      urlParams.delete("filter.v.price.gte");
      urlParams.delete("filter.v.price.lte");

      window.location.search = urlParams.toString();
    });
  }
}
